import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import PulseLoader from "react-spinners/PulseLoader";
import i18next from "i18next";
import axios from "axios";
import { Image } from "hesus-ui-kit";
import { useGetGeneralParameters } from "@hooks/useGeneralParams";
import UserInfo from "@utils/UserInfo";
import settingIcon from "@icons/ic-settings.svg";
import addWidgetIcon from "@icons/ic-add-widget.svg";
import AddEditDashboardWidget from "../AddEditDashboardWidget";
import DashboardEnquiryList from "./components/DashboardEnquiryList";
import DashboardLeadList from "./components/DashboardLeadList";
import DashboardSiteList from "./components/DashboardSiteList";

import {
  DashboardContainer,
  DashboardWidgetContainer,
  MainTitle,
  FlexRow,
  SettingWrapper,
  SectionContainer,
  GridRow,
  GridSubItem,
  OuterWrapper,
  NoWidget,
  PlusSign,
} from "./DashboardView.styled";
import "./DashboardView.scss";
/**
 * Dashboard view,
 * Path - /
 * @see See [https://hesusstore.atlassian.net/wiki/spaces/HS/pages/3354918916/Homepage+-+Dashboard)
 * @component
 */
const DashboardView = (props) => {
  const { t } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [widgetData, setWidgetData] = useState([]);
  const [isRefreshList, setIsRefreshList] = useState(false);
  const [isWidgetPopupVisible, setIsWidgetPopupVisible] = useState(false);

  const countryId = UserInfo.countryId();
  const userInfo = UserInfo.getUser();

  const generalParams = useGetGeneralParameters();

  const fetchWidgetInfo = () => {
    axios
      .get(`/dashboard/${userInfo.id}/widgets`)
      .then((response) => {
        setIsLoading(false);
        setWidgetData(response.data.dashboardWidgets);
      })
      .catch((error) => {});
  };

  useEffect(() => {
    if (Object.keys(generalParams).length > 0) fetchWidgetInfo();
  }, [generalParams]);

  const updateWidget = () => {
    setIsWidgetPopupVisible(true);
  };

  const closeWidgetPopup = () => {
    setIsWidgetPopupVisible(false);
  };

  useEffect(() => {
    if (isRefreshList) {
      fetchWidgetInfo();
      setIsRefreshList(false);
    }
  }, [isRefreshList]);

  return (
    <DashboardContainer className="contact-notes-list">
      {isLoading && (
        <div className="suggestions-list-loading">
          <PulseLoader color="#1bace4" size={15} />
        </div>
      )}

      {!isLoading && Object.keys(generalParams).length > 0 && (
        <>
          <FlexRow>
            <MainTitle>
              {t("DASHBOARD_WELCOME") + " " + userInfo.firstName}
            </MainTitle>
            <SettingWrapper>
              <Image
                src={settingIcon}
                alt={t("DASHBOARD_SETTING_ICON")}
                onClick={updateWidget}
                className="dashboard-widget-view-site__image_setting_icon"
              />
            </SettingWrapper>
          </FlexRow>

          {widgetData.length === 0 && (
            <OuterWrapper>
              <FlexRow>
                <SectionContainer>
                  <FlexRow>
                    <GridRow>
                      <GridSubItem color="#474747">
                        {t("DASHBOARD_NO_WIDGET")}
                      </GridSubItem>
                    </GridRow>
                  </FlexRow>
                  <GridRow column="1fr 1fr">
                    <NoWidget>
                      <PlusSign onClick={updateWidget}>
                        <Image
                          src={addWidgetIcon}
                          height="150px"
                          width="90px"
                          alt={t("DASHBOARD_ADD_ICON")}
                          className="dashboard-widget-view-site__image_add_widget_icon"
                        />
                      </PlusSign>
                    </NoWidget>
                  </GridRow>
                </SectionContainer>
              </FlexRow>
            </OuterWrapper>
          )}
        </>
      )}
      {!isLoading && widgetData.length > 0 && (
        <OuterWrapper>
          <FlexRow>
            <SectionContainer>
              <DashboardWidgetContainer>
                {widgetData.map((widget) => {
                  return (
                    <React.Fragment
                      key={"dashboard-view-widget-list-" + widget.id}
                    >
                      {widget.id === 1 && (
                        <DashboardEnquiryList
                          widgetName={widget.name}
                          widgetId={widget.id}
                          userId={userInfo.id}
                          countryId={countryId}
                        />
                      )}
                      {widget.id === 2 && (
                        <DashboardLeadList
                          widgetName={widget.name}
                          widgetId={widget.id}
                          userId={userInfo.id}
                          countryId={countryId}
                        />
                      )}
                      {widget.id === 3 && (
                        <DashboardSiteList
                          widgetName={widget.name}
                          widgetId={widget.id}
                          userId={userInfo.id}
                          countryId={countryId}
                        />
                      )}
                    </React.Fragment>
                  );
                })}
              </DashboardWidgetContainer>
            </SectionContainer>
          </FlexRow>
        </OuterWrapper>
      )}
      {isWidgetPopupVisible && (
        <AddEditDashboardWidget
          selectedWidget={widgetData}
          onClose={closeWidgetPopup}
          setIsRefreshList={setIsRefreshList}
          adminId={userInfo.id}
        />
      )}
    </DashboardContainer>
  );
};

DashboardView.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.number,
};

DashboardView.defaultProps = {
  id: null,
};

export default withTranslation()(DashboardView);
